import React, { useEffect } from "react";
import { useState } from "react";
import { validationFLFQueryTypeInput } from "src/pages/FPTLife/utils/validateInput";
import Controls from "src/components/form/controls/Controls";
import { isDisableSubmit } from "src/utils";
import useForm, { Form } from "src/hooks/useForm";

const initialValue = {
  id: "",
  name: "",
  slug: "",
};

function FLFQueryTypeForm(props) {
  const { addOrEdit, recordForEdit, errorsForm } = props;
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  // validation input permission
  const validateFLFQueryTypeForm = (fieldValues = values) => {
    let temp = validationFLFQueryTypeInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFQueryTypeForm);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateFLFQueryTypeForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="name"
        value={values.name}
        label="Name"
        type="text"
        onChange={handleOnChange}
        error={errors.name}
      />

      {recordForEdit ? (
        <Controls.Input
          name="slug"
          value={values.slug}
          label="Slug"
          type="text"
          onChange={handleInputChange}
        />
      ) : null}

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
}

export default FLFQueryTypeForm;
